module.exports = __webpack_public_path__ + "static/media/201CS158.1a09af8b.jpg";